import { portkeyDidUIPrefix } from './index';

export const SET_GLOBAL_LOADING = `${portkeyDidUIPrefix}event-setGlobalLoading`;
export const SET_SERVICE_CONFIG = `${portkeyDidUIPrefix}event-setServiceConfig`;
export const SET_RECAPTCHA_CONFIG = `${portkeyDidUIPrefix}event-setReCaptchaConfig`;
export const SET_RECAPTCHA_MODAL = `${portkeyDidUIPrefix}event-setReCaptchaModal`;
export const SERVICE_AUTH_CHANGE = `${portkeyDidUIPrefix}event-serviceAuthChange`;
